export interface RecycledAsset {
  id: string;
  name: string;
  category: string | null;
  deletedAt: string | null;
}

interface RecycledRow {
  id: string;
  name: string;
  category_id: string | null;
  deleted_at: string | null;
}

/** Maps a raw recycled property_assets row to the bin's display shape. */
export function mapRecycledRow(
  row: RecycledRow,
  categoryNameById: Map<string, string>,
): RecycledAsset {
  return {
    id: row.id,
    name: row.name,
    category: (row.category_id && categoryNameById.get(row.category_id)) || null,
    deletedAt: row.deleted_at,
  };
}
